// Avatar Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'

class Avatar extends Component {
  static get propTypes () {
    return {
      imageUrl: PropTypes.string,
      defaultImage: PropTypes.string,
      type: PropTypes.oneOf(['normal', 'small', 'big']),
      title: PropTypes.string.isRequired
    }
  }

  static get defaultProps () {
    return {
      imageUrl: '',
      defaultImage: '',
      type: 'normal',
      title: ''
    }
  }

  shouldComponentUpdate (nextProps, _nextState) {
    const { imageUrl, defaultImage, type, title } = this.props
    if (
      imageUrl !== nextProps.imageUrl ||
      defaultImage !== nextProps.defaultImage ||
      type !== nextProps.type ||
      title !== nextProps.title
    ) {
      return true
    }
    return false
  }

  render () {
    const { imageUrl, type, defaultImage, title } = this.props

    return (
      <div className={`cavatar${type ? ' cavatar_' + type : ''}`}>
        <img
          className='image'
          src={imageUrl || defaultImage}
          alt={title}
          title={title}
        />
      </div>
    )
  }
}

export default Avatar
